import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import React from 'react';
export const childrenToArray = children => {
  var _context;
  const newFirstChildren = [];
  _forEachInstanceProperty(_context = React.Children).call(_context, children, child => {
    newFirstChildren.push(child);
  });
  return newFirstChildren;
};